<template>
    <rkm-form
        ref="RkmForm"
        show-legend
    >
        <rkm-row>
            <rkm-col>
                <rkm-form-input
                    v-if="['', null, undefined].includes(data.model.telefoneNumero)"
                    :validations="validations.telefoneNumero"
                    label="Telefone"
                    v-model="data.model.telefoneNumero"
                />

                <rkm-form-input
                    v-else-if="data.model.telefoneNumero.length < 15"
                    :validations="validations.telefoneNumero"
                    label="Telefone"
                    v-mask="mask.phone"
                    v-model="data.model.telefoneNumero"
                />

                <rkm-form-input
                    v-else
                    :validations="validations.telefoneNumero"
                    label="Telefone"
                    v-mask="mask.cellPhone"
                    v-model="data.model.telefoneNumero"
                >
                    <rkm-input-group-append slot="append">
                        <rkm-input-group-text>
                            <rkm-form-checkbox v-model="data.model.telefoneAutorizaSms">
                                Autoriza envio de SMS
                            </rkm-form-checkbox>
                        </rkm-input-group-text>
                    </rkm-input-group-append>
                </rkm-form-input>
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Mixins.
import {mask} from '@/mixins'

export default {
    computed: {
        validations() {
            return {
                telefoneNumero: {
                    required: true,
                    min_max_without_mask: [10, 11],
                },
            }
        },
    },
    methods: {
        save() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    if (this.data.model.telefoneNumero.length < 15) {
                        this.data.model.telefoneAutorizaSms = false
                    }

                    this.$emit('saved')
                })
        },
    },
    mixins: [mask],
    props: {
        data: {type: Object, required: true},
    },
}
</script>
